import { styled, tabClasses, tabsClasses } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';

interface GridContainerProps extends BoxProps {
  variant?: 'approve-charges' | 'single-job';
}

export const GridContainer = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'variant',
})<GridContainerProps>(({ theme, variant }) => {
  const isSingleJobVariant = variant === 'single-job';

  if (variant === 'approve-charges') {
    return {
      alignContent: 'start',
      backgroundColor: theme.semantic.surfacePage,
      display: 'grid',
      gridTemplateColumns: '1fr',
      margin: theme.spacing(-4, -5),
      minHeight: 'calc(100vh - 135px - var(--tread-agent-dock-height, 0px))',
    };
  }

  return {
    backgroundColor: theme.brandV2.colors.treadGray8,
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: isSingleJobVariant ? '1fr' : 'auto auto 1fr',
    height: isSingleJobVariant
      ? 'calc(100vh - 65px - var(--tread-agent-dock-height, 0px))'
      : 'calc(100vh - 135px - var(--tread-agent-dock-height, 0px))',
    margin: theme.spacing(-4, -5),
  };
});

export const GridRow = styled(Box)(({ theme }) => ({
  backgroundColor: theme.semantic.surfaceRaised,
  borderTop: `solid 1px ${theme.palette.divider}`,
  padding: theme.spacing(1, 6),
}));

export const ExpandedBlockTabs = styled(Tabs)(({ theme }) => ({
  [`&.${tabsClasses.root}`]: {
    marginTop: theme.spacing(2),
    minHeight: 'auto',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  [`& .${tabsClasses.list}`]: { gap: theme.spacing() },
  [`& .${tabsClasses.indicator}`]: {
    backgroundColor: theme.brandV2.colors.treadBlack,
    borderRadius: 0,
    height: '2px',
  },
  [`& .${tabClasses.root}`]: {
    fontSize: '12px',
    lineHeight: '32px',
    minHeight: 'auto',
    minWidth: 'auto',
    padding: theme.spacing(0, 1),
    [`&.${tabClasses.selected}`]: { color: theme.brandV2.colors.treadBlack },
  },
}));

export const FlexColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const FlexRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
}));
